import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from './app.service';
import { Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {  
  constructor(private appService: AppService,
    public router: Router) {

  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }



}
